<template>
  <div>
    <div
      class="mb-md-3 bg-form-header d-flex justify-content-between align-items-center p-md-2 p-1 rounded"
    >
      <b-media class="d-flex align-items-center" no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            size-md="45"
            size="30"
            class="rounded-avatar bg-secondary"
          />
        </b-media-aside>
        <b-media-body class="d-flex align-items-center text-white">
          <h4 class="font-weight-bolder text-white mb-0">Basic Information</h4>
          <feather-icon
            icon="HelpCircleIcon"
            size-md="16"
            class="font-weight-bolder ml-1 rounded-circle cursor-pointer"
            v-b-tooltip.hover="'Basic Information'"
          />
        </b-media-body>
      </b-media>

      <b-form-group class="warning-button">
        <b-form-checkbox
          v-model="active"
          name="active"
          class="flex-row-reverse"
          switch
          inline
          :uncheckedValue="0"
          :value="1"
        >
          active
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-row class="p-2">
      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Competition name :"
          label-for="competition-name"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Competition name"
            vid="competition-name"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input id="competition-name" v-model="name" />

              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'This name will appear as the title of competition on your page'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- <b-col class="d-flex" lg="4">
        <b-form-group
          label="Select category :"
          label-for="select-category"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Select category"
            vid="select-category"
            class="w-100"
          >
            <div class="d-flex justify-content-start align-items-center">
              <select-box
                id="select-category"
                v-model="category_id"
                label="text"
                class="w-100"
                select="id"
                searchable
                url="category"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Indicate which category this competition falls into'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col> -->
      <!-- <b-col class="d-flex" lg="4">
        <b-form-group
          label="Select sponsor :"
          label-for="select-sponsor"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Select sponsor"
            vid="select-sponsor"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <select-box
                id="select-sponsor"
                v-model="sponsor_id"
                label="text"
                class="w-100"
                select="id"
                searchable
                url="sponsor"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Sponsor is the person or the institution who is financially supporting this competition'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col> -->
      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Select brokers :"
          label-for="select-brokers"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Select brokers"
            vid="select-brokers"
            class="w-100"
          >
            <div class="d-flex justify-content-start align-items-center">
              <select-box
                id="brokers"
                v-model="brokers"
                label="text"
                class="w-100"
                select="id"
                searchable
                multiple
                url="broker"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Select the name of the broker on which all the trades will take place'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Select symbol :"
          label-for="select-symbol"
          class="w-100"
          rules="required"
        >
          <validation-provider
            #default="{ errors }"
            name="select symbol"
            vid="select-symbol"
            class="w-100"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input
                id="select-symbol"
                v-model="symbol"
                placeholder="example : BTCUSDT"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="' '"
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col class="d-flex" lg="4">
        <b-form-group label-for="type" class="w-100" label="Type">
          <b-button-group class="mb-md-1 mt-50">
            <b-button
              :variant="type == 'DEMO' ? 'warning' : 'outline-warning'"
              @click="type = 'DEMO'"
              class="mr-50"
            >
              Forex demo
            </b-button>
            <b-button
              :variant="type == 'REAL' ? 'warning' : 'outline-warning'"
              @click="type = 'REAL'"
              class="ml-50"
            >
              Forex real
            </b-button>
            <!-- <b-button
              :variant="type == 'crypto' ? 'warning' : 'outline-warning'"
              @click="type = 'crypto'"
              style="
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
              "
            >
              Crypto
            </b-button> -->
          </b-button-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="my-2">
        <hr />
      </b-col>
      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Registration start date:"
          label-for="registration-start-date"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="registration start date"
            vid="registration-start-date"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <flat-pickr
                @click.native="blurPicker"
                id="registration-start-date"
                v-model="registration_begin"
                class="form-control"
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                }"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Set the exact time when people can start registering in the competition'
                "
              />
            </div>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Registration deadline / competition start :"
          label-for="registration-deadline/competition-start"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="registration deadline / competition start"
            vid="registration-deadline/competition-start"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <flat-pickr
                @click.native="blurPicker"
                id="registration-deadline/competition-start"
                v-model="registration_end"
                class="form-control"
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                }"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'After this time nobody can register in the competition'
                "
              />
            </div>
            <small class="text-danger" v-if="!checkRegistrationEnd">{{
              errors[0]
            }}</small>
            <small class="text-danger" v-if="checkRegistrationEnd"
              >The registration deadline / competition start date must be
              greater than registration start date
            </small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col class="d-flex" lg="4">
        <b-form-group
          label="Competition end :"
          label-for="competition-end"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="competition end"
            vid="competition-end"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <flat-pickr
                @click.native="blurPicker"
                id="competition-end"
                v-model="ended_at"
                class="form-control"
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                }"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="' '"
              />
            </div>
            <small class="text-danger" v-if="!checkEndAt">{{
              errors[0]
            }}</small>
            <small class="text-danger" v-if="checkEndAt"
              >The competition end date must be greater than registration
              deadline/competition start date
            </small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-col class="d-flex" lg="4">
        <b-form-group
          label="Duration (hours) :"
          label-for="duration"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Duration"
            vid="duration"
            class="w-100"
            rules="required|max-value:30"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input
                id="duration"
                v-model="duration"
                type="number"
                min="1"
              />

              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="' '"
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col> -->
      <b-col class="d-flex" lg="4" v-if="userData.type == 'admin'">
        <b-form-group
          label="Refresh interval (minutes) :"
          label-for="refresh_interval"
          class="w-100"
        >
          <validation-provider
            #default="{ errors }"
            name="Refresh interval"
            vid="refresh_interval"
            class="w-100"
            :rules="`required|min-value:${
              userData.plan && userData.plan.chart_update_duration
                ? Number(userData.plan.chart_update_duration) * 60
                : 2
            }`"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input
                id="refresh_interval"
                v-model="refresh_interval"
                type="number"
                :min="
                  userData.plan && userData.plan.chart_update_duration
                    ? Number(userData.plan.chart_update_duration) * 60
                    : 2
                "
              />

              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'How long is your competition going to run for?'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="my-2">
        <hr />
      </b-col>
      <b-col class="d-flex flex-column mb-2 px-2" xl="4" md="6" cols="12">
        <validation-provider
          #default="{ errors }"
          name="thumbnail"
          vid="thumbnail"
          class="position-relative"
        >
          <div
            v-if="thumbnailPreview || thumbnail"
            class="d-flex align-items-center justify-content-center py-3"
          >
            <b-img
              ref="previewEl"
              :src="thumbnailPreview || thumbnail || errorImage"
              :alt="name"
              fluid
              rounded
              class="p-25"
              @error="setAltImg"
            />
          </div>
          <b-avatar
            ref="previewEl"
            :alt="name"
            style="height: 150px; width: 100%"
            rounded="lg"
            class="bg-secondary text-muted"
            v-else
          >
            <feather-icon icon="ImageIcon" size="60" class="mb-3" />
          </b-avatar>
          <small class="text-danger" v-if="!thumbnail">{{ errors[0] }}</small>
          <div
            class="d-flex w-100 justify-content-center banner-btns flex-wrap my-2"
          >
            <b-button
              :class="[
                thumbnailPreview || thumbnail ? 'gradient-btn' : 'border',
                'ml-50 px-75',
              ]"
              @click="$refs.refInputEl.click()"
            >
              <input
                @input="changeCover"
                ref="refInputEl"
                type="file"
                class="d-none"
                id="thumbnail"
                accept="image/*"
              />
              <span class="d-none d-sm-inline">Upload</span>
              <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
            </b-button>
            <b-button
              class="ml-50 px-75 border"
              @click="removeCover"
              :disabled="!thumbnail"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </validation-provider>
        <loader :loading="loading" />
      </b-col>
      <b-col xl="8" md="6" cols="12" class="mb-1">
        <div class="bg-secondary rounded-lg p-2">
          <h5 class="font-weight-bolder text-white pb-50">
            Competition thumbnail
          </h5>
          <div class="d-flex flex-column">
            <span :class="`mb-50  text-${invalidImageSize && 'danger'}`">
              1) The image size should not exceed 1MBs.
            </span>
            <span class="mb-50">
              2) The aspect ratio of the thumbnail must be xyz*8wdj.pixels.
            </span>
            <span>
              3) The picture should contain information about your competition.
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BButtonGroup,
  BButton,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  VBTooltip,
} from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import flatPickr from "vue-flatpickr-component";
import Loader from "@core/components/loader/Loader.vue";
let moment = require("jalali-moment");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BButtonGroup,
    BButton,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BImg,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    SelectBox,
    flatPickr,
    Loader,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: "",
      // category_id: "",
      // sponsor_id: "",
      registration_begin: null,
      registration_end: null,
      started_at: null,
      ended_at: null,
      // duration: "",
      refresh_interval: "",
      type: "DEMO",
      symbol: "",
      active: 1,
      brokers: [],
      thumbnailPreview: "",
      thumbnail: "",
      thumbnailWatch: "",
      loading: false,
      invalidImageSize: false,
      required,
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    checkRegistrationEnd() {
      let registration_begin_x = moment(this.registration_begin).format("X");
      let registration_end_x = moment(this.registration_end).format("X");
      return registration_end_x <= registration_begin_x;
    },
    checkEndAt() {
      let registration_end_x = moment(this.registration_end).format("X");
      let ended_at_x = moment(this.ended_at).format("X");
      return registration_end_x >= ended_at_x;
    },
    validDate() {
      return !this.checkRegistrationEnd && !this.checkEndAt;
    },
    basicInformation() {
      let newData = {
        name: this.name,
        // category_id: this.category_id,
        // sponsor_id: this.userData.id,
        registration_begin: this.registration_begin,
        registration_end: this.registration_end,
        started_at: this.started_at,
        ended_at: this.ended_at,
        duration: this.duration,
        symbol: this.symbol,
        active: this.active,
        type: this.type,
        refresh_interval: this.refresh_interval,
        brokers: this.brokers,
      };
      !this.$route.params.id && (newData.thumbnail = this.thumbnail);
      return newData;
    },
  },
  watch: {
    validDate: {
      handler(val) {
        this.$emit("validDate", val);
      },
      immediate: true,
      deep: true,
    },
    registration_end(val) {
      this.started_at = val;
    },
    competition(val) {
      Object.keys(val).map((item) => {
        if (item == "brokers") {
          this[item] = val[item].data.map((item) => item.id);
        } else if (item == "active") {
          this[item] = val[item] ? 1 : 0;
        } else if (item == "registration_begin") {
          this[item] = this.toLocal(val[item]);
        } else if (item == "registration_end") {
          this[item] = this.toLocal(val[item]);
        } else if (item == "ended_at") {
          this[item] = this.toLocal(val[item]);
        } else if (item == "started_at") {
          this[item] = this.toLocal(val[item]);
        } else if (item == "refresh_interval") {
          this[item] =
            this.userData.plan && this.userData.plan.chart_update_duration
              ? Number(this.userData.plan.chart_update_duration) * 60
              : 2;
        } else {
          this[item] = val[item];
        }
      });
    },
    basicInformation(val) {
      this.$emit("basicInformation", val);
    },
  },
  methods: {
    async removeCover() {
      if (this.$route.params.id) {
        this.loading = true;
        try {
          await this.$http.delete(
            `panel/competitions/${this.$route.params.id}/thumbnail`
          );
          await this.$emit("getCompetition");
        } catch (err) {}
        this.loading = false;
      } else {
        this.thumbnail = "";
        this.thumbnailPreview = "";
        this.$refs.refInputEl.value = "";
      }
    },
    async changeCover(e) {
      if (e.target.files[0].size < 1000000) {
        this.invalidImageSize = false;
        if (this.$route.params.id) {
          this.loading = true;
          try {
            let formData = new FormData();
            formData.append("thumbnail", e.target.files[0]);
            const { data } = await this.$http.post(
              `panel/competitions/${this.$route.params.id}/thumbnail?_method=patch`,
              formData
            );
            this.$refs.refInputEl.value = "";
            await this.$emit("getCompetition");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Competition thumbnail Updated",
                icon: "EditIcon",
                variant: "success",
              },
            });
          } catch (err) {}
          this.loading = false;
        } else {
          this.thumbnail = e.target.files[0];
          this.thumbnailPreview = URL.createObjectURL(this.thumbnail);
        }
      } else {
        this.invalidImageSize = true;
      }
    },
  },
};
</script>
